// extracted by mini-css-extract-plugin
module.exports = {"root":"Book_root__teK24","hide":"Book_hide__hYGYm","title":"Book_title__2Feyh","centerContent":"Book_centerContent__CpF7Y"};